import '../../pages/TryoutSettingsPage.css';

import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { RecordQualityKey } from '../../components/common/CameraRecorder/CameraRecorder';
import PageTopNav from '../../components/common/PageTopNav/PageTopNav';
import {
  getVideoQuality,
  saveVideoQuality,
  VIDEO_QUALITY_OPTIONS,
} from '../../utils/videoQualitySettings';

const DemoTryoutSettingsPage: React.FC = () => {
  const navigate = useNavigate();
  const [quality, setQuality] = useState<RecordQualityKey>(() => getVideoQuality());

  const handleQualityChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const next = e.target.value as RecordQualityKey;
    setQuality(next);
    saveVideoQuality(next);
  };

  return (
    <div className="tryout-settings-shell">
      <PageTopNav
        title="Settings"
        onBack={() => navigate('/demo/tryout')}
        backAriaLabel="Back to tryout"
      />

      <div className="tryout-settings-content">
        <section className="tryout-settings-card">
          <div className="tryout-settings-row">
            <div className="tryout-settings-row-label">
              <span className="tryout-settings-row-title">Video Recording Quality</span>
              <span className="tryout-settings-row-desc">Lower qualities will upload faster</span>
            </div>
            <div className="tryout-settings-select-wrap">
              <select
                className="tryout-settings-select"
                value={quality}
                onChange={handleQualityChange}
                aria-label="Video recording quality"
              >
                {VIDEO_QUALITY_OPTIONS.map(o => (
                  <option key={o.key} value={o.key}>{o.label}</option>
                ))}
              </select>
              <svg className="tryout-settings-select-chevron" viewBox="0 0 24 24" fill="none" aria-hidden>
                <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default DemoTryoutSettingsPage;
